<template>
  <svg
    class="delete-icon"
    :width="width"
    :height="height"
    viewBox="0 96 960 960"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    :style="{ '--delete-icon-color': color }"
  >
    <path
      d="M261 936q-24.75 0-42.375-17.625T201 876V306h-41v-60h188v-30h264v30h188v60h-41v570q0 24-18 42t-42 18H261Zm438-630H261v570h438V306ZM367 790h60V391h-60v399Zm166 0h60V391h-60v399ZM261 306v570-570Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'DeleteIcon',
  props: {
    color: {
      type: String,
      default: '#98A2B3'
    },
    height: {
      type: String,
      default: '16px'
    },
    width: {
      type: String,
      default: '16px'
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-icon {
  color: var(--delete-icon-color, #98a2b3);
  cursor: pointer;
  transition: color 0.18s ease;

  &:hover {
    color: #f04438;
  }
}
</style>
